<template>
	<div class="initial-motivation">
		<speaker-notes :notes="currentNotes"></speaker-notes>
		<h2>Previous Attempts</h2>
		<h3><span class="not">X</span>QuickTime's MIDI generator</h3>
		<div :class="`flex details ${part === 1 ? 'open' : 'closed'}`">
			<div>
				<img src="@/assets/images/quicktime.png" alt="quicktime logo"/>
			</div>
			<div>
				<ul>
					<li>Worked great in 2010 everywhere (except IE).</li>
					<li>Ok, pretty much just Firefox and Safari.</li>
					<li>And only for shortish pieces.</li>
					<li>And only QuickTime 6. (version 7 removed MIDI support.)</li>
				</ul>
			</div>
		</div>
		<div v-if="part > 1">
			<h3><span class="not">X</span>&lt;audio&gt; control</h3>
			<div :class="`flex details ${part === 2 ? 'open' : 'closed'}`">
				<div>
					<img src="@/assets/images/audio-element.png" alt="quicktime logo"/>
				</div>
				<div>
					<ul>
						<li>Not available in all browsers (at the time).</li>
						<li>Hard to control - it doesn't promise exact timing.</li>
						<li>Don't provide very good random access.</li>
					</ul>
				</div>
			</div>
		</div>
		<div v-if="part > 2">
			<div v-if="part === 3">
				<h3><span class="not">X</span>midi.js</h3>
				<div :class="`flex details ${part === 3 ? 'open' : 'closed'}`">
					<div>
						<img src="@/assets/images/midijs-logo.png" alt="quicktime logo"/>
					</div>
					<div>
						<ul>
							<li>Tries to work everywhere with a series of fallbacks. Performance only ok in fast browsers/computers.</li>
							<li>The performance was so bad on non-ideal systems that silence was much better.</li>
							<li>It was designed for a different purpose (reading midi files.)</li>
							<li>It is largish. (added about 70k).</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import PageParts from "../helpers/page-parts";
	import SpeakerNotes from "../components/SpeakerNotes";
	export default {
		name: "initial-motivation",
		components: {SpeakerNotes},
		mixins: [
			PageParts,
		],
		data() {
			return {
				notes: [
					[
						"Greg Dyke created output in MIDI format; made it the address of a quicktime object.",
						"Browsers were ok with loading things like Quicktime.",
						"Quicktime could read a MIDI file and use built in sounds and construct the audio",
					],
					[
						"I tried using the built in audio control from HTML5.",
						"It just wasn't performant enough.",
						"I couldn't get it to play at the moment I wanted it to."
					],
					[
						"Then I found an open source library that looked like it would work.",
						"And it did, on my computer.",
						"I did a little hacking: change input to array; fix a couple of bugs",
						"AudioContext wasn't widely available",
						"The fallbacks didn't work well.",
					],
				],
			};
		},
	}
</script>

<style lang="scss" scoped>
	.not {
		font-family: Itim, sans-serif;
		color: $not-color;
		font-size: 1.2em;
		padding-right: 10px;
	}
	.details {
		overflow: hidden;
		transition: max-height .5s ease-in-out;
		&.closed {
			max-height: 0;
		}
		&.open {
			max-height: 400px;
		}
	}
	@media screen and (min-width: 490px) {
		.flex {
			display: flex;
			align-items: center;
			margin-left: 100px;

			& > div {
				margin-right: 20px;
			}
		}
	}
	h2 {
		text-align: center;
	}
	h3 {
		margin: 0;
	}
</style>
